module.exports = __webpack_public_path__ + "static/media/HB1@2x.220d9b09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/HB/HB1@2x.png
// module id = 274
// module chunks = 0